import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import { nextCookies } from '@chegg-me-components/utils';
var cookieAgeOneDay = 60 * 60 * 24;
export var cookieAgeOneYear = cookieAgeOneDay * 365;
export var LANG_PREFERENCE_COOKIE = 'langPreference';
/**
 * @param langLocale - The selected locale to be saved in `langPreference` cookie
 * @returns This function sets a cookie with the name langPreference and the value of langLocale. The cookie will expire after one year. After setting the cookie, the page reloads.
 */

export function saveLanguageCookie(langLocale, cookieDomain) {
  nextCookies().set(LANG_PREFERENCE_COOKIE, langLocale, {
    maxAge: cookieAgeOneYear,
    domain: cookieDomain || window.location.hostname
  });
  window.location.reload();
} // Finds if langPreference cookie is present. Returns -1 if not found.

export function getCookieLangIndex(selectorData, cookies) {
  return selectorData.findIndex(function (lang) {
    return lang.langLocale === cookies[LANG_PREFERENCE_COOKIE];
  });
} // Finds the index of the locale passed as defaultLocale to the LanguageSelector package

export function getDefaultLangIndex(selectorData, defaultLocale) {
  return selectorData.findIndex(function (lang) {
    return lang.langLocale === defaultLocale;
  });
}
export function useListboxBehaviour(options, onLanguageSelect) {
  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      pseudoFocusedListboxIndex = _useState2[0],
      setPseudoFocusedListboxIndex = _useState2[1];

  var decrementPseudoIndex = function decrementPseudoIndex() {
    var nextFocus = pseudoFocusedListboxIndex - 1; // don't cycle from the start to the end

    if (nextFocus < 0) {
      nextFocus = 0;
    }

    setPseudoFocusedListboxIndex(nextFocus);
  };

  var incrementPseudoIndex = function incrementPseudoIndex() {
    var nextFocus = pseudoFocusedListboxIndex + 1; // don't cycle from the end to the start

    if (nextFocus > options.length - 1) {
      nextFocus = options.length - 1;
    }

    setPseudoFocusedListboxIndex(nextFocus);
  };

  var onListboxKeyDown = function onListboxKeyDown(event) {
    switch (event.key) {
      case 'ArrowUp':
      case 'Up':
        {
          decrementPseudoIndex();
          break;
        }

      case 'ArrowDown':
      case 'Down':
        {
          incrementPseudoIndex();
          break;
        }

      case 'Enter':
        onLanguageSelect(pseudoFocusedListboxIndex);
        break;

      case 'Escape':
      case 'Home':
        setPseudoFocusedListboxIndex(0);
        break;
    }

    event.stopPropagation();
    event.preventDefault();
  };

  return {
    pseudoFocusedListboxIndex: pseudoFocusedListboxIndex,
    onListboxKeyDown: onListboxKeyDown
  };
}